export const STATUS_DONE = 'Done'
export const STATUS_NOT_STARTED = 'Not Started'
/** Em dash — used when lesson-instructor role is not set */
export const STATUS_NA = '\u2014'

/**
 * Maps completion counts to Done / Not Started / — for the DWB report variant.
 * @param {number|undefined|null} count - Completed trainings for this track
 * @param {number} total - Required trainings for completion
 * @param {boolean} teachesLessonsDefined - Same gate as K-8 grid (`teachesLessons !== undefined`)
 */
export function trainingCompletionStatus(count, total, teachesLessonsDefined) {
  if (!teachesLessonsDefined) {
    return STATUS_NA
  }
  const n = count === undefined || count === null ? 0 : count
  if (n >= total) {
    return STATUS_DONE
  }
  return STATUS_NOT_STARTED
}
